import Vue from 'vue'
import Router from 'vue-router'

import HomeRoutes from './home'
import DemosRoutes from './demos'
import BusinessesRoutes from './businesses'
import SearchRoutes from './search'
import RegisterRoutes from './register'
import LoginRoutes from './login'
import ManageRoutes from './manage'
import AccountRoutes from './account'
import SellpointRoutes from './sellpoint'
import PurchaseRoutes from './purchase'
import CreateSellpointRoutes from './create'
import CartRoutes from './cart'
import OrderRoutes from './order'
import CheckoutRoutes from './checkout'
import OrdersRoutes from './orders'
import TermsRoutes from './terms'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        HomeRoutes,
        TermsRoutes,
        DemosRoutes,
        BusinessesRoutes,
        SearchRoutes,
        RegisterRoutes,
        LoginRoutes,
        ManageRoutes,
        PurchaseRoutes,
        AccountRoutes,
        CreateSellpointRoutes,
        CartRoutes,
        OrderRoutes,
        CheckoutRoutes,
        OrdersRoutes,
        SellpointRoutes,
        // {path: '*', redirect: '/'} // 404
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js